// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_qn-8";
export var editMode = "_qn-3";
export var headerRow = "_qn-a";
export var headerTitle = "_qn-b";
export var product = "_qn-1";
export var productDetails = "_qn-5";
export var productDivider = "_qn-7";
export var productImage = "_qn-2";
export var productInfo = "_qn-4";
export var productTitle = "_qn-6";
export var strikethrough = "_qn-9";
export var upsellProductsCard = "_qn-0";